import { EmptyState } from "../EmptyState";
import type { IEmptyStateProps } from "../EmptyState/types";
import { useTableContext } from "./context";

export const TableEmptyState = () => {
  const { emptyState } = useTableContext();

  const emptyStateProps: IEmptyStateProps = {
    size: "sm",
    ...emptyState,
  };

  return (
    <div className="nuco-table__empty-state" role="row">
      <div className="nuco-table__empty-state-cell" role="gridcell">
        <EmptyState {...emptyStateProps} />
      </div>
    </div>
  );
};
